import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';


export class ControlUser extends BaseModel implements Deserializable {

  public static UserTypeAdmin: string = "Admin";
  public static UserTypeOwner: string = "Owner";
  public static UserTypeUser: string = "User";
  public static UserTypeAlias: string = "Alias";
  public static UserTypeService: string = "Service";


  id: number;
  uid: string;
  email: string;
  username: string;
  firebaseUid: string;
  userType: string;
  displayName: string;

  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }
}
